import { EmissorPaymentMethod } from './types';
export function getRecommendedEmissorPaymentMethod({ showAccountBalance, hasSufficientBalance, showPix, showBankSlip, }) {
    const visibleCount = Number(showAccountBalance) + Number(showPix) + Number(showBankSlip);
    if (visibleCount <= 1) {
        return null;
    }
    if (showAccountBalance && hasSufficientBalance) {
        return EmissorPaymentMethod.ACCOUNT_BALANCE;
    }
    if (showPix) {
        return EmissorPaymentMethod.PIX;
    }
    return null;
}
